
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import { scrollWatcher } from '~/helpers/scroll-watcher.js';
import { homePageWatcher } from "~/helpers/is-main-page";

export default BaseCmsBlock.extend({
  name: "CalculatorBlock",

  head: function () {
    // preload отдаём через imagesrcset/imagesizes: браузер сам выберет тот же вариант,
    // что и <img srcset> (раньше мобильные грузили desktop-версию 1920px на 163 КБ)
    let links = [
      {
        as: "image",
        rel: "preload",
        href: this.mainImage,
        imagesrcset: this.imageSrcset,
        imagesizes: "100vw",
        type: "image/webp",
        fetchpriority: "high",
      }
    ];

    return {
      link: links
    }
  },

  data: function () {
    return {
      cityFrom: "",
      cityTo: "",

      isClickCityFrom: true,

      isAnimate: true,
      isAccept: true,
      // '--animate-banner-calculator__substrate': isAnimate && isVisibleVideo && isHome || isAnimate && mainImage && isHome,
    }
  },

  props: {
    dark: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    rootClassName: function () {
      return [
        this.$additionalBlockClasses(this.cfgs),
        Boolean(this.isHome) && 'home-page-full-width',
      ].filter((t) => !!t).join(' ')
    },

    startCity: function () {
      return this.$store.state?.appState?.config?.city?.model?.name || ""
    },

    localValues: function () {
      return this.externalData?.CalculatorBlock || this.values || {}
    },

    title: function () {
      const catsTitle = (this.values?.cats_titles || []).find((t) => t.category === this.externalData?.CalculatorBlock?.categoryId)?.title;
      return catsTitle || this.localValues.title
    },
    isDark: function () {
      return this.dark || this.externalData?.CalculatorBlock?.dark || false
    },
    useH1: function () {
      return this.cfgs?.use_h1 || this.externalData?.CalculatorBlock?.useH1 || false
    },
    useFormFeedback: function () {
      return this.cfgs?.use_form_feedback || this.externalData?.CalculatorBlock?.use_form_feedback || false
    },

    isVisibleVideo: function () {
      if (!process.client) {
        return false
      }
      if (!this.extras.video) {
        return false
      }
      if (window.innerWidth <= 1023) {
        return false
      }
      return true
    },

    mainImage: function () {
      // дефолтный src (для браузеров без srcset); реальный размер выбирает srcset
      return this.$img(String(this.localValues.image), {
        width: 1024,
        height: 1000,
        fit: 'contain',
        quality: 72,
      })
    },

    imageSrcset: function () {
      const src = String(this.localValues.image)
      if (!src || src === 'undefined' || src === 'null') {
        return undefined
      }
      return [640, 1024, 1440, 1920]
        .map((width) => `${this.$img(src, { width, height: 1000, fit: 'contain', quality: 72 })} ${width}w`)
        .join(', ')
    },

    isHome: function () {
      return homePageWatcher(this.$route.fullPath)
    },
  },

  components: {
    InputDropDown: () => import("./components/CalculatorBlock/InputDropDown"),
    FormFeedback: () => import("./components/CalculatorBlock/FormFeedback"),
  },

  mounted: function () {
    this.startVideo();
    this.initForm();
  },

  methods: {
    initForm: function () {
      this.cityFrom = this.startCity;
    },
    startVideo: function () {
      if (!this.extras.video) {
        return
      }
      if (window?.innerWidth < 1024) {
        return;
      }
      if (!this.$refs.refVideo) {
        setTimeout(() => {
          this.startVideo();
        }, 500);
        return;
      }
      // preload="metadata": перед play() страхуемся, что браузер начал загрузку ресурса
      if (this.$refs.refVideo.readyState === 0) { this.$refs.refVideo.load(); }
      const playPromise = this.$refs.refVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') { playPromise.catch(() => {}); }
    },

    changeCity: function (name, city) {
      this[name] = city;

      if (this.cityFrom && this.cityTo && false) {
        this.submitForm();
      }
    },
    reverseCity: function () {
      const cityFrom = this.cityFrom;
      const cityTo = this.cityTo;

      this.cityFrom = cityTo;
      this.cityTo = cityFrom;
    },
    clickCityFrom: function () {
      if (!this.isClickCityFrom) {
        return
      }

      this.cityFrom = "";
      this.isClickCityFrom = false;
    },

    submitForm: function () {
      let messages = [];
      if (!this.cityFrom) {
        messages.push("Выберите город отправления")
      }
      if (!this.cityTo) {
        messages.push("Выберите город прибытия")
      }
      if (messages.length > 0) {
        this.$toast.error(messages.join(";<br/>"));

        return
      }

      this.$router.push(`/cargo-rate-calculator?from=${this.cityFrom}&to=${this.cityTo}`);
    },
    inFieldOfView: function () {
      if (scrollWatcher('banner-calculator')) {
        document.removeEventListener('scroll', this.inFieldOfView);
        this.isAnimate = true;
      }
    },
  }
});
